import { MonitorActivity } from '../models/monitor-activity.model';
import { Observable } from 'rxjs';

/**
 * This class is used to describe the monitor service provider
 */
export abstract class MonitorActivityProvider {
  /**
   * This method is used for getting authentication information
   * about user
   * @abstract
   */
  abstract isAuthenticated(): Promise<boolean>;

  /**
   * This method is used for saving activities to the server
   * @param activities The list of activities to save
   * @abstract
   */
  abstract save(activities: MonitorActivity[]): Observable<void>;
}
